import { render, staticRenderFns } from "./Scenario.vue?vue&type=template&id=4f48d544&"
import script from "./Scenario.vue?vue&type=script&lang=ts&"
export * from "./Scenario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports